export const isNumeric = (value: string) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  !isNaN(value as any) && !isNaN(parseInt(value))
